import { type InputHTMLAttributes, forwardRef } from 'react';
import { cn } from '../../lib/utils';

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type, ...props }, ref) => (
    <input
      type={type}
      ref={ref}
      className={cn(
        // Bo 4px, viền đậm hơn đường kẻ bố cục, **không** đổ bóng — APM-LIST-b.
        // Bóng dưới một ô nhập là thứ còn sót lại của giao diện bắt chước giấy;
        // ở một màn hình dày ô nhập nó chỉ làm cả bảng trông mờ.
        'flex h-9 w-full rounded-control border border-border-strong bg-background px-3 py-1 text-sm transition-colors',
        // Focus tô **viền xanh** thay vì vẽ thêm một vòng bên ngoài: vòng ngoài
        // đẩy các ô cạnh nó xê dịch trong một hàng chật.
        'focus-visible:border-primary focus-visible:outline-none',
        'placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50',
        // Ô sai được đánh dấu bằng `aria-invalid`, không phải bằng class riêng:
        // screen reader đọc được, và style đi kèm miễn phí.
        'aria-invalid:border-destructive',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';
